// SPDX-License-Identifier: AGPL-3.0-or-later

export function getRuntimeTimeZoneOffsetMinutes(timeZone: string | null | undefined): number | null {
	const value = timeZone?.trim();
	if (!value) {
		return null;
	}
	const now = new Date();
	try {
		const parts = new Intl.DateTimeFormat('en-US', {
			timeZone: value,
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit',
			hourCycle: 'h23',
		}).formatToParts(now);
		const values = new Map(parts.map((part) => [part.type, part.value]));
		const year = Number(values.get('year'));
		const month = Number(values.get('month'));
		const day = Number(values.get('day'));
		const hour = Number(values.get('hour'));
		const minute = Number(values.get('minute'));
		const second = Number(values.get('second'));
		if ([year, month, day, hour, minute, second].some((part) => Number.isNaN(part))) {
			return null;
		}
		const zonedAsUtc = Date.UTC(year, month - 1, day, hour, minute, second);
		return Math.round((zonedAsUtc - (now.getTime() - now.getUTCMilliseconds())) / 60_000);
	} catch {
		return null;
	}
}
